module.exports = __webpack_public_path__ + "img/tradesperson.9902bc6a.jpg";